import { useInitGTM } from '@spa/core/externals/gtm'
import { routes } from '@spa/core/router/appRoutesConfig'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { SignupSplitLayout } from '../../shared/layouts/SignupSplitLayout'

import { AccountCreation } from './AccountCreation'
import { AccountCompanyInfoStep } from './steps/AccountCompanyInfoStep/AccountCompanyInfoStep'
import { AccountUserInfoStep } from './steps/AccountUserInfoStep/AccountUserInfoStep'

export const AccountCreationRoutes = React.memo(() => {
  useInitGTM()

  return (
    <Routes>
      <Route element={<SignupSplitLayout />}>
        <Route element={<AccountCreation />}>
          <Route
            path={routes.accountCreationUserInfo.path}
            element={<AccountUserInfoStep />}
          />
          <Route
            path={routes.accountCreationCompanyInfo.path}
            element={<AccountCompanyInfoStep />}
          />
          <Route
            path='*'
            element={
              <Navigate to={routes.accountCreationUserInfo.path} replace />
            }
          />
        </Route>
      </Route>
    </Routes>
  )
})
